import { render, staticRenderFns } from "./TableHeadersSort.vue?vue&type=template&id=5f4671a6&scoped=true&"
import script from "./TableHeadersSort.vue?vue&type=script&lang=js&"
export * from "./TableHeadersSort.vue?vue&type=script&lang=js&"
import style0 from "./TableHeadersSort.vue?vue&type=style&index=0&id=5f4671a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4671a6",
  null
  
)

export default component.exports